export default __webpack_public_path__ + "static/robo-password-reset.png";